import styles from "./toolbox-components.module.css";

import {
  aspectRatioFromPreset,
  PosterSizePreset,
  sizeInCMFromPreset,
  sizeInInchesFromPreset,
} from "PosterEditor/model/poster-project";
import { useEditorUI } from "PosterEditor/use-editor-ui";

interface ToolboxComponentPosterSizeIconProps {
  preset: PosterSizePreset;
  isSelected: boolean;
  onClick: () => void;
}

export const ToolboxComponentPosterSizeIcon = (
  props: ToolboxComponentPosterSizeIconProps
) => {
  const { editorUIState } = useEditorUI();
  const titleForPreset = (preset: PosterSizePreset) => {
    const size =
      editorUIState.unitMeasurement === "cm"
        ? sizeInCMFromPreset(preset)
        : sizeInInchesFromPreset(preset);
    return `${size.width} x ${size.height}`;
  };

  interface Size {
    width: number;
    height: number;
  }

  const size = (preset: PosterSizePreset): Size => {
    const aspectRatio = aspectRatioFromPreset(preset);
    const size = sizeInInchesFromPreset(preset);
    const largestSizeInInches = 20;
    const relativeWidth =
      Math.max(size.width, size.height) / largestSizeInInches;

    const largest = 100;
    if (aspectRatio > 1) {
      return {
        width: largest * relativeWidth,
        height: (largest / aspectRatio) * relativeWidth,
      };
    } else {
      return {
        width: largest * aspectRatio * relativeWidth,
        height: largest * relativeWidth,
      };
    }
  };

  return (
    <button
      onClick={props.onClick}
      className={`${styles.posterSizeIcon} ${
        props.isSelected ? styles.posterSizePresetIconSelected : ""
      }`}
      style={{
        width: size(props.preset).width,
        height: size(props.preset).height,
      }}
    >
      <span
        className={
          props.isSelected
            ? styles.posterSizePresetIconTitleSelected
            : styles.posterSizePresetIconTitle
        }
      >
        {titleForPreset(props.preset)}
      </span>
    </button>
  );
};
